import React, { Component } from 'react'
import { Spin } from 'antd'

import './LoadingPage.scss'

export default class LoadingPage extends Component {
    render() {
        const { loadingText } = this.props

        return (
            <div className="LoadingPage">
            	<Spin size="large" tip={loadingText}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/LoadingPage/LoadingPage.js